import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Snackbar
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';

type AlertSomethingWentWrongProps = {
  open: boolean;
  setOpen: (f:boolean) => void;
  extra?: string;
};

export const AlertSomethingWentWrong: FunctionComponent<AlertSomethingWentWrongProps> = ({extra, open, setOpen}) => {
  const {t, i18n} = useTranslation(['translations']);
  const [snackOpen, setSnackOpen] = useState<boolean>(open);

  return (<>
    <Snackbar
      open={snackOpen}
      onClose={() => {setSnackOpen(false); if (!!setOpen) setOpen(false);}}
      autoHideDuration={6000}
    >
      <MuiAlert elevation={6} variant="filled" severity="error">
        {t("alerts.somethingwentwrong").replace(/<[^>]*>?/gm, '')} {extra}
      </MuiAlert>
    </Snackbar>
  </>);
}